import * as Yup from 'yup';

export const formValidation = Yup.object().shape({
    workFlowName: Yup.string().required('Name is Required'),
    levels: Yup.number()
        .typeError('Levels must be a number')
        .required('Levels are required')
        .min(1, 'Levels must be at least 1'),
});